<template>
  <div class="d-block d-sm-inline-block">
    <div class="d-block d-sm-inline-block">
      <label class="mt-2" for="month">เดือน:</label>
    </div>
    <div class="d-block d-sm-inline-block input my-2 my-sm-0 mx-sm-2">
      <v-select
        id="month"
        :items="months"
        v-model="month"
        item-text="text"
        item-value="value"
        outlined
        dense
        hide-details/>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      month: 1,
      months: [],
    }
  },
  props: {
    value: { types: Number, require: true }
  },
  mounted() {
    this.month = this.value
    moment.locale('th')
    this.genMonths()
  },
  watch: {
    month (newVal, oldVal) {
      if (newVal !== oldVal) this.$emit('input', newVal)
    },
    value (newVal) {
      this.month = newVal
    },
  },
  methods: {
    genMonths() {
      let i = -1
      this.months = moment.months().map((text) => {
        i ++
        return { text, value: i }
      })
    },
  },
}
</script>